// @flow
import type { Dispatch } from 'redux';
import { finectAPI } from '@finect/front-utils/finectAPI';

export function setSettingFetchingStatus(setting: string, fetching: boolean, fetched?: boolean) {
  return {
    type: 'SET_SETTING_FETCHING_STATUS',
    setting,
    fetching,
    fetched
  };
}

export function setSetting(setting: string, value: any) {
  return {
    type: 'SET_SETTING',
    setting,
    value
  };
}

/**
 * Trae un ajuste del backoffice (`resources/setting/:id`) al store.
 *
 * Guarda el valor TAL CUAL: es la única vía para leer un ajuste, así que no puede interpretar lo
 * que trae. Antes le hacía un spread y le añadía un `tag` derivado del id, y eso se comía los
 * valores que no eran objetos —un número quedaba en `{ tag: '...' }`, y así estuvo muerto meses el
 * interruptor de SonIA en los comparadores—. Quien lea el valor es quien sabe qué forma tiene.
 *
 * Un 404 —el ajuste no existe— se guarda como null, que es información igual de válida que un
 * valor y evita que quien lo lee vuelva a pedirlo.
 *
 * Devuelve la promesa de la petición, así que se puede encadenar desde un loadInitialData para que
 * el ajuste llegue resuelto al SSR.
 *
 * @param id Identificador del ajuste
 */
export function fetchSetting(id: string) {
  return (dispatch: Dispatch) => {
    dispatch(setSettingFetchingStatus(id, true, true));
    return finectAPI({
      version: 'v4',
      path: `resources/setting/${id}`,
      method: 'GET',
      onSuccess: ({ data }: { data: Object }) => dispatch(setSetting(id, data.value)),
      onError: () => dispatch(setSetting(id, null))
    });
  };
}

export function setPlusModal(open: boolean) {
  return {
    type: 'SET_PLUS_MODAL',
    open
  };
}
